export default class MailMember {

  generateAIMessage() {
    var overlay = document.getElementById('ai-generate-overlay');
    if (overlay) overlay.style.display = 'block';

    fetch('https://' + gon.api_domain + '/v1/chatgpt/resume_summary_for_company', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        work_history_ids: document.getElementById('work_history_ids').value,
        summary_length: document.getElementById('summary_length').value,
        extra_instructions: document.getElementById('extra_instructions').value,
        member_id: gon.member_id,
        site_lang: gon.locale,
        lang: gon.locale
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      document.getElementById('ai-generated-text').value = data.message;
    })
    .catch(() => {
      document.getElementById('ai-generated-text').value = gon.generate_failed;
    })
    .finally(() => {
      if (overlay) overlay.style.display = 'none';
    });
  };

  openAIGenerateModal() {
    var modal = document.getElementById('ai-generate-modal');
    modal.style.display = 'block';
    modal.classList.add('show');
    document.body.classList.add('modal-open');
    // Add backdrop
    var backdrop = document.createElement('div');
    backdrop.className = 'modal-backdrop fade show';
    backdrop.id = 'ai-generate-backdrop';
    document.body.appendChild(backdrop);
  }

  closeAIGenerateModal() {
    var modal = document.getElementById('ai-generate-modal');
    modal.style.display = 'none';
    modal.classList.remove('show');
    document.body.classList.remove('modal-open');
    // Remove backdrop
    var backdrop = document.getElementById('ai-generate-backdrop');
    if (backdrop) backdrop.remove();
  }

  copyGeneratedText() {
    var textarea = document.getElementById('ai-generated-text');
    var feedback = document.getElementById('copy-feedback');
    if (textarea && feedback) {
      navigator.clipboard.writeText(textarea.value).then(function() {
        feedback.textContent = gon.copy_success;
        feedback.className = 'align-middle ml-3 mt-1';
        feedback.style.visibility = 'visible';
        setTimeout(function() {
          feedback.style.visibility = 'hidden';
        }, 3000);
      }).catch(function(err) {
        feedback.textContent = gon.copy_failed;
        feedback.className = 'alert alert-danger mt-2';
        feedback.style.visibility = 'visible';
        console.error('Unable to copy text: ', err);
        setTimeout(function() {
          feedback.style.visibility = 'hidden';
        }, 2000);
      });
    }
  }

  setupEventListeners() {
    window.addEventListener('DOMContentLoaded', function() {
      var btn = document.getElementById('ai-generate-btn');
      if (btn) {
        btn.addEventListener('click', () => mailMember.openAIGenerateModal() );
      }
    });
  }
}

const mailMember = new MailMember();
mailMember.setupEventListeners();
